import moment from 'moment';
import { Entity } from '../index.js';
// A document hangs off a case or off a creditor. Nothing else is modelled, so
// the enum is narrowed rather than widened when Entity grows.
export const documentEntities = [Entity.Case, Entity.Creditor];
export const legacyDocumentReferenceTypes = {
    [Entity.Case]: 'CASE',
    [Entity.Creditor]: 'CREDITOR',
};
export var DocumentTypes;
(function (DocumentTypes) {
    DocumentTypes["FOUNDATION"] = "FOUNDATION";
    DocumentTypes["SKYLDERKLAERING"] = "SKYLDERKLAERING";
    DocumentTypes["COURTOPGJORTOGFREMLAGT"] = "COURTOPGJORTOGFREMLAGT";
    DocumentTypes["DOM"] = "DOM";
    DocumentTypes["PAATEGNING"] = "PAATEGNING";
    DocumentTypes["FORLIG"] = "FORLIG";
    DocumentTypes["COURT"] = "COURT";
    DocumentTypes["OTHER"] = "OTHER";
    DocumentTypes["GAELDSBREV"] = "GAELDSBREV";
})(DocumentTypes || (DocumentTypes = {}));
export const DocumentTypesHumanized = {
    [DocumentTypes.FOUNDATION]: ['Fundament'],
    [DocumentTypes.SKYLDERKLAERING]: ['Skylderklæring'],
    [DocumentTypes.COURTOPGJORTOGFREMLAGT]: ['Opgjort og fremlagt i retten'],
    [DocumentTypes.DOM]: ['Dom'],
    [DocumentTypes.PAATEGNING]: ['Påtegning'],
    [DocumentTypes.FORLIG]: ['Forlig'],
    [DocumentTypes.COURT]: ['Retligt'],
    [DocumentTypes.OTHER]: ['Andet'],
    [DocumentTypes.GAELDSBREV]: ['Gældsbrev'],
};
export const documentsThatExtendExpirationInDenmark = {
    signingNotRequired: [
        DocumentTypes.DOM,
        DocumentTypes.PAATEGNING,
        DocumentTypes.COURTOPGJORTOGFREMLAGT,
        DocumentTypes.GAELDSBREV,
    ],
    signingRequired: [
        DocumentTypes.FOUNDATION,
        DocumentTypes.SKYLDERKLAERING,
        DocumentTypes.FORLIG,
    ],
};
export const documentsWhichIsFoundations = {
    signingNotRequired: [
        DocumentTypes.DOM,
        DocumentTypes.PAATEGNING,
        DocumentTypes.GAELDSBREV,
    ],
    signingRequired: [
        DocumentTypes.FOUNDATION,
        DocumentTypes.SKYLDERKLAERING,
        DocumentTypes.FORLIG,
    ],
};
export const isDocumentFoundation = (document) => {
    if (documentsWhichIsFoundations.signingNotRequired.includes(document.type)) {
        return true;
    }
    if (documentsWhichIsFoundations.signingRequired.includes(document.type) &&
        document.signedAt) {
        return true;
    }
    return false;
};
export const doesDocumentExtendExpiration = (document) => {
    if (documentsThatExtendExpirationInDenmark.signingNotRequired.includes(document.type)) {
        return true;
    }
    if (documentsThatExtendExpirationInDenmark.signingRequired.includes(document.type) &&
        document.signedAt) {
        return true;
    }
    return false;
};
// Debtors and creditors calculate with these without seeing the documents.
export const limitationDocuments = (documents) => documents
    .filter(doesDocumentExtendExpiration)
    .map(({ type, date, signedAt }) => ({ type, date, signedAt }));
export const getFoundations = (documents) => {
    const foundations = documents.filter(isDocumentFoundation);
    if (foundations.length > 1) {
        foundations.sort((a, b) => {
            // returns newest first
            if (moment(a.date) > moment(b.date)) {
                return -1;
            }
            else if (moment(a.date) < moment(b.date)) {
                return 1;
            }
            return 0;
        });
    }
    return foundations;
};
export const getDocumentsThatExtendExpiration = (documents) => {
    return documents.filter(doesDocumentExtendExpiration);
};
//# sourceMappingURL=index.js.map